import React from 'react';

export function Events() {
  return (
    <><div>
    <div className="events"><h2>EVENTS</h2></div>
</div>
<div>
  <h3 style={{color:"red",textAlign:"center"}}>! No events right now !</h3>
</div>
</>
  );
}
